module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-support-8e994cb19f3a01e0965467cebab3a62c.png";